import { Component } from 'react'

import { withRouter } from 'react-router-dom'

import Controller, { IProps, IState } from './controller'

import Button, { Variant } from 'common/components/button'
import Icons from 'common/components/icons'

export class LegalAlert extends Component<IProps, IState> {
  controller: Controller

  constructor(props: IProps) {
    super(props)
    this.controller = new Controller(this)
  }

  componentDidMount() {
    this.controller.loadTos()
  }

  componentDidUpdate() {
    if (this.state.title) {
      const $title = document.querySelector('.legal-alert-body > .title > .content')

      if ($title) {
        $title.innerHTML = this.state.title
      }
    }

    if (this.state.text) {
      const $content = document.querySelector('.legal-alert-body > .content')

      if ($content) {
        $content.innerHTML = this.state.text
      }
    }

    if (this.state.buttonText) {
      const $button = document.querySelector('.legal-alert-body > .legal-footer > button')

      if ($button) {
        $button.innerHTML = this.state.buttonText
      }
    }
  }

  render() {
    const { isAccepted } = this.props
    const { valid } = this.state
    const { onAccept } = this.controller

    return !valid && !isAccepted && (
      <div className="legal-alert">
        <div className="legal-alert-body">
          <div className="title">
            <Icons prefix="far" iconName="cookie-bite"/>
            <span className="content" />
          </div>
          <div className="content" />
          <div className="legal-footer">
            <Button
              variant={Variant.SUCCESS}
              onClick={onAccept}
              data-test="btn-legal-accept" />
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(LegalAlert)
